export default "__VITE_ASSET__MSKFu7gQ__"